export default "__VITE_ASSET__DeO94aHG__"